import { useEffect, useState } from 'react'
import { defineQuery } from 'groq'
import { getClient } from '../client'
import { DEFAULT_LANG } from '@autoplan/common'
import { useLang } from '../i18n/LocaleProvider'
import { useLiveVersion } from './useLiveVersion'
import type { HOME_QUERY_RESULT } from '../sanity.types'

const HOME_QUERY = defineQuery(`{
  "page": *[_type == "homePage" && _id == "singleton-homePage"][0] {
    newsHeading, headerImage
  },
  "featuredArticle": *[_type == "newsArticle" && isFeatured == true && language == $lang] | order(publishedAt desc)[0] {
    _id, title, slug, image, body
  },
  "articles": *[_type == "newsArticle" && language == $lang] | order(publishedAt desc)[0...3] {
    _id, title, slug, image, body
  },
  "infoCards": *[_type == "informationCard"] | order(order asc) {
    _id, label, buttonLabel, actionType, url
  }
}`)

export type HomeContent = HOME_QUERY_RESULT

export function useHomeContent() {
  const [content, setContent] = useState<HomeContent | null>(null)
  const lang = useLang()

  const live = useLiveVersion()

  useEffect(() => {
    let active = true
    getClient()
      .fetch(HOME_QUERY, { lang })
      .then((result) =>
        result.articles.length > 0 || lang === DEFAULT_LANG
          ? result
          : getClient().fetch(HOME_QUERY, { lang: DEFAULT_LANG }),
      )
      .then((result) => active && setContent(result))

    return () => {
      active = false
    }
  }, [lang, live])

  return content
}
